<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div class="bargain">
    <div class="title">
      <div class="title_text">订单详情</div>
    </div>
    <div class="bargain_core_box">
      <div class="bargain_core">
        <div
          class="bargain_pic"
          :style="{background: `url(${userinfo.avatar})50% 50% / cover no-repeat`}"
        ></div>
        <div class="bargain_username">{{userinfo.nickname}}</div>
        <div class="bargain_tit">“我发现一件好货，一起来砍价0元拿”</div>
        <div class="bargain_commodity">
          <div
            class="bargain_pict"
            :style="{background: `url(${shareslist.thumb})50% 50% / cover no-repeat`}"
          ></div>
          <div class="bargain_rig">
            <div class="bargain_tits">{{shareslist.title}}</div>
            <div class="bargain_over">
              <div>￥{{infolist.payPrice}}</div>
              <div>{{goodslist.sales}}人已0元拿</div>
            </div>
          </div>
        </div>
        <div class="progress_bar">
          <div class="stocks" v-if="infolist.status != '2'">
            已砍
            <span>{{infolist.dedPrice}}</span>元, 还差
            <span>{{infolist.shengPrice}}</span>元
          </div>
           <div class="bargain_over" v-else>恭喜您砍价成功啦！即将为您安排发货~</div>
          <div class="progress_bar_box">
            <div class="progress_bars" :style="{width:infolist.speed + '%'}"></div>
          </div>
          <div class="bargain_button" @click="bargain_button()">
            <div>{{bang_bargain}}</div>
          </div>
          <div class="bargain_count_down">还剩{{shengyutime}}过期，快来砍价吧~</div>
        </div>
        <div class="bargain_bang">
          <div class="bargain_bang_top"></div>
          <div class="bargain_bang_core">
            <div
              class="bargain_bang_core_list"
              v-for="(item,index) in allList.bargainList"
              :key="index"
            >
              <div
                class="core_pic"
                :style="{background: `url(${item.userInfo.avatar})50% 50% / cover no-repeat`}"
              ></div>
              <div class="core_usernamr">{{item.userInfo.nickname}}</div>
              <div class="core_delprice">-￥{{item.price}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <div class="bargain_win_box" v-show="win_del">
      <div class="bargain_win">
        <div class="bargain_win_core">
          <div class="win_one">
            <input type="number" v-model="bobilePhone" placeholder="请输入手机号" />
          </div>
          <div class="win_two">
            <input type="number" v-model="smsCode" placeholder="请输入验证码" />
            <div v-show='getinivernum' @click="getiniver()">获取验证码</div>
            <div v-show='!getinivernum'>{{invnum}}</div>
          </div>
          <div class="win_three">
            <input type="text" v-model='invite' readonly="readonly" placeholder="请输入邀请码或邀请人手机号" />
          </div>
          <div class="win_four" @click="login()">
            <div>确定</div>
          </div>
        </div>
      </div>
      <div class="del">
        <img @click="del()" src="../assets/bargain/guanbi.png" alt />
      </div>
    </div>
    <!-- 砍价成功 -->
    <div class="bargain_popup_win_box"  v-show="popupWin">
            <div class="bargain_popup_win">
                <div class="bargain_popup_core">
                    <div class="pic_top" :style="{background: `url(${userinfo.avatar})50% 50% / cover no-repeat`}"></div>
                    <div class="bargain_popup_core_top"><div>谢谢你帮我砍了</div><div>{{banglist.price}}元</div></div>
                    <div class="progress_bar_box">
                        <div class="progress_bars" :style="{width:banglist.speed + '%'}"></div>
                    </div>
                    <div class="progress_again">
                      <div>你也可以砍价免费拿哦，快去挑选</div>
                      <div>心仪的商品吧~</div>
                    </div>
                    <div class="share_botton" @click="toAccreditss()">我也要免费拿！</div>
                    <img class="shut_share" @click='cancle(2)' src="../assets/bargain/guanbi.png" alt="">
                </div>
            </div>
        </div>
    <!-- 砍价过期弹窗 -->
    <div class="bargain_overdue_box" v-show="overdueWin">
      <div class="bargain_overdue">
        <div class="bargain_overdue_head_box">
          <div
            class="bargain_overdue_head"
            :style="{background: `url(${userinfo.avatar})50% 50% / cover no-repeat`}"
          ></div>
        </div>
        <div class="bargain_overdue_txtone">
          <div class="symbol_left"></div>
          <div class="symbol_center">啊哦~我的砍价已过期</div>
          <div class="symbol_right"></div>
        </div>
        <div class="bargain_overdue_txttwo">送你一件免费商品，快来挑选吧</div>
        <div class="share_botton" @click="toAccreditss()">马上去选</div>
        <img class="shut_share" @click="cancle(1)" src="../assets/bargain/guanbi.png" alt />
      </div>
    </div>
     <!-- 分享弹窗 -->
     <div class="wechat-pop">
        <mt-popup
            v-model="wechatPop"
            position="top">
            <img src="../assets/pintuan/wechatBrowser.png" alt="">
        </mt-popup>
    </div>

  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import axios from "axios";
import "swiper/dist/css/swiper.css";
import qs from 'qs'
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "bargain",
  components: {},
  data() {
    return {
      win_del: false,
      allList: [],
      datas: {},
      countDownunm: "",
      shengyutime: "",
      overdueWin: false,
      bobilePhone : '', //手机号
      smsCode: '', //验证码
      invite : '', //邀请码
      getinivernum:  true,
      popupWin: false,
      bang_bargain: '帮好友砍一刀',
      userinfo: [],
      infolist:[],
      goodslist:[],
      shareslist:[],
      banglist : [],
      wechatPop: false,
      invnum:'60',
      uid : '', //分享人uid
      udid: '', //砍价人uid
      bizId : '',
      token: '',
      orderId: "",
      codeInfo: '',
      code: "",
      url: '',
      TT: '',
      uas : '',
      shareInfo : '',
      tiaozhuan : 1,
      codeVersion : '',
      activeAll:[]
    };
  },
  created() {
    axios.defaults.headers = {
        'Content-type': 'application/x-www-form-urlencoded'
      }
      axios.defaults.transformRequest = (data) => {
        data = qs.stringify(data)
        return data
      }
      this.code = this.GLOBAL.getQueryString('code')
      this.orderId = this.GLOBAL.getQueryString('orderId')
      this.codeInfo = this.GLOBAL.getQueryString('codeInfo')
      this.codeVersion = this.GLOBAL.getQueryString('codeVersion')
      this.device = this.deviceType()
      console.log("code:",this.code,"orderId:",this.orderId,"codeinfo:",this.codeInfo)
      let promiseArr = {};
        let cancel = {};
        axios.interceptors.request.use(
          config => {
            // 发起请求时，取消掉当前正在进行的相同请求
            if (promiseArr[config.url]) {
              // promiseArr[config.url]('操作取消')
              promiseArr[config.url] = cancel
            } else {
              promiseArr[config.url] = cancel
            }
            const token = this.token
            if (token) {
              config.headers.token = token
            }
            return config
          },
          err => {
            return Promise.reject(err)
          }
        )
        this.uas = window.navigator.userAgent.toLowerCase();

  },
  mounted() {
    this.getstyle();
    this.countDown();
  },
  methods: {
    // getsytle
    getstyle(){
      axios.get(this.GLOBAL.apiUrlNative + "/api/w1/share/download?code=" + this.code).then(res => {
        console.log(1)
        this.datas = res.data.data
        this.bizId = res.data.data.bizId;
        this.invite = res.data.data.invite_code;
        this.shareInfo = res.data.data.shareInfo
        this.url = res.data.data.oauthUrl;
        console.log("***********",'app://' + this.shareInfo.APP_DOWNLOAD_BAO_ANDROID + '/openapp')
        this.styleTxt(this.bizId,this.orderId)
        if(this.codeInfo){
          this.wxlogin(this.bizId,this.codeInfo)
        }
      });
    },
    // 微信砍价
    wxlogin(bizId,codeInfo){
       axios.post(this.GLOBAL.apiUrlNative + '/api/' + bizId +'/amoy/auth/we-login',{type: 'mp', code: codeInfo}).then((ress) => {
          console.log(ress,ress.code,ress.data.code)
          if(ress.data.code === 0){
              this.token = ress.data.data.token;
              // console.log("微信帮人砍一刀",this.token)
              axios.post(this.GLOBAL.apiUrlNative +"/api/" +this.bizId +"/mall/activity/bargaining-bang" 
              ,{token: this.token, orderId:this.orderId} ,false).then(res => {
                console.log(res.data.code)
              if(res.data.code === 0){
                this.popupWin = true ;
                this.bang_bargain = '我也要免费拿！';
                this.tiaozhuan = 2;
                this.banglist = res.data.data;
                this.styleTxt(bizId,this.orderId)
              }else{
                  this.bang_bargain = '我也要免费拿！';
                  this.tiaozhuan = 2;
              }
              
              
            })
          }
      })
    },
    // 样式渲染
    styleTxt(bizId,orderId){
      axios.post(this.GLOBAL.apiUrlNative +"/api/" +bizId +"/mall/activity/bargaining-info?orderId=" + orderId).then(res => {
            console.log(2)
            this.allList = res.data.data;
            this.countDownunm = this.allList.info.limittime;
            this.userinfo = this.allList.userInfo;
            this.shareslist = this.allList.shares;
            this.infolist = this.allList.info;
            this.goodslist = this.allList.goods;
            this.uid = this.allList.userInfo.uid
            if(this.infolist.status == 2){
               this.bang_bargain = '砍价成功！'
               clearInterval(this.TT)
               this.shengyutime = '00:00:00'
               return
            }
            if( this.uid == this.udid){
              Toast('本人订单无法 重复砍价！')
              this.bang_bargain = '本人订单无法 重复砍价！'
              return
            }
          });
    },
    // 砍一刀
    bargain_button() {
      console.log(this.infolist.status)
      if(this.infolist.status == 1 && this.tiaozhuan == 1){
        console.log("this.countDownunm", this.countDownunm)
        if (this.uas.match(/MicroMessenger/i) == "micromessenger") {
          console.log(this.codeInfo)
          if(this.codeInfo == null){
            //  console.log(this.codeInfo,2)
             window.location.href = this.url + '/api/' + this.bizId + '/wechat/auth/login?activityUrl=' + 
             encodeURIComponent(window.location.href)
          }
        }else{
          console.log("不是微信浏览器");
          if(!this.token){
            this.win_del = true;
          }else{
            axios.post(this.GLOBAL.apiUrlNative +"/api/" +this.bizId +"/mall/activity/bargaining-bang" ,{token: this.token,orderId:this.orderId} ,false).then(res => {
                this.banglist = res.data.data
                console.log(4,this.banglist)
                if(res.data.code == 0){
                  Toast('砍价成功！')
                  this.getstyle()
                  this.bang_bargain = '我也要免费拿！';
                  this.tiaozhuan = 2;
                }else{
                  this.bang_bargain = '我也要免费拿！';
                  this.tiaozhuan = 2;
                }
              })
          }
        }
        if(this.token && this.countDownunm <=0){
            Toast('订单已过期无法继续砍价！')
            return
        }
        if( this.uid == this.udid){
          Toast('本人订单无法 重复砍价！')
          this.bang_bargain = '本人订单无法 重复砍价！'
          return
        }
        if(this.bang_bargain=='砍价成功！'){
          this.$router.push({
              path: '/download',
              query: {code: this.code, codeVersion: this.codeVersion}
          })
        }
      }
      if(this.infolist.status == 1 && this.tiaozhuan == 2){
        // Toast({
        //     message: '砍价已成功，无法继续砍价！',
        //     className: 'coln'
        //   })
        this.$router.push({
              path: '/download',
              query: {code: this.code, codeVersion: this.codeVersion}
          })
      }
      
    },
    // 微信浏览器 登录
    weixinInit() {
      console.log(this.url + '/api/' + this.bizId + '/wechat/auth/login?activityUrl=' + encodeURIComponent(window.location.href))
      window.location.href = this.url + '/api/' + this.bizId + '/wechat/auth/login?activityUrl=' + encodeURIComponent(window.location.href)
    },
    //手机号登录
    login(){
      var regexs = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if(!regexs.test(this.bobilePhone)){
         Toast({
          message: '手机号不正确',
          className: 'coln'
        })
        return
      }
      if(!this.smsCode){
        Toast({
          message: '短信验证码不能为空',
          className: 'coln'
        })
        return
      }else{
        this.gettoken();
      }
    },
    //
    gettoken (){
      axios.post(this.GLOBAL.apiUrlNative +"/api/" +this.bizId +"/amoy_v2/auth/login",{mobile: this.bobilePhone,sms_code: this.smsCode, invite_code: this.invite},false).then(res => {
            // console.log(res.data.data.token)
            console.log(3)
            this.udid = res.data.data.uid
            this.token = res.data.data.token;
            this.bobilePhone = '';
            this.smsCode = '';
            if(res.data.code == 0){
              this.win_del = false ;
              axios.post(this.GLOBAL.apiUrl +"/api/" +this.bizId +"/mall/activity/bargaining-bang" 
              ,{token: this.token, orderId:this.orderId} ,false).then(res => {
                this.banglist = res.data.data
                console.log(4,this.banglist)
                if(res.data.code == 0){
                  Toast('砍价成功！')
                  this.styleTxt(this.bizId,this.orderId)
                  this.bang_bargain = '我也要免费拿！';
                  this.tiaozhuan = 2;
                }else{
                  // Toast('砍价成功，无法继续砍价！')
                  this.bang_bargain = '我也要免费拿！';
                  this.tiaozhuan = 2;
                }
              })
            }
          })
    },
    //手机号登录 获取验证码
    getiniver(){
      var regex = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if(regex.test(this.bobilePhone)){
        this.getinivernum = false;
        var invtime = setInterval(()=>{
          this.invnum--;
          if(this.invnum ==0){ clearInterval(invtime);this.getinivernum = true;this.invnum ='60'}
        },1000);
        axios.post(this.GLOBAL.apiUrl +"/api/" +this.bizId +"/amoy_v2/auth/login-sms",{mobile: this.bobilePhone},false).then(res => {
          Toast({
            message: '短信已发送，请注意查收！',
            className: 'coln'
          })
        })
      }else{
        Toast({
          message: '手机号不正确',
          className: 'coln'
        })
      }
    },
    del() {
      this.win_del = false;
    },
    //过期弹窗
    cancle(num) {
      if(num == 1){
      this.overdueWin = false;
      }
      if(num == 2){
        this.popupWin = false
      }
    },
    deviceType () {
        let u = navigator.userAgent
        // android终端
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        // ios终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
            return 'ios'
        } else if (isAndroid) {
            return 'android'
        } else {
            return 'other'
        }
    },
    toAccreditss(){
          this.$router.push({
              path: '/download',
              query: {code: this.code, codeVersion: this.codeVersion}
          })
      //  this.toAccredit()
    },
    // 去授权
    toAccredit(){
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) { 
        // 引导图显示
        this.wechatPop = true
        }else{
            // 唤醒app
            if(this.device === 'ios'){
                 window.location.href = this.shareInfo.APP_DOWNLOAD_BAO_IOS
            }else{
                window.location.href = 'app://' + this.shareInfo.APP_DOWNLOAD_BAO_ANDROID + '/openapp?name=main'
            }
            
             let href = ''
             if(this.datas.download_type == 'two-in-one'){
                href = this.datas.two_in_one
             }else{
                if(this.device === 'ios'){
                    href = this.datas.ios
                }else{
                    href = this.datas.android
                }
             }
           let clickedAt = +new Date();
            setTimeout(function () {
                // webkitHidden检测页面对于用户的可见性(切换标签或者切换后台就不可见了)
                !window.document.webkitHidden && setTimeout(function () {
                    if (+new Date() - clickedAt < 2000) {
                        window.location = href;
                    }
                }, 500);
            }, 500)
        }
    },
    // 计时器
    timeFormat: function(param) {
      return param < 10 ? "0" + param : param;
    },
    countDown: function(it) {
      var that = this;
        this.TT = setInterval(() => {
        let time = that.countDownunm;
        var obj;
        if (that.countDownunm >= 0) {
          let dd = parseInt(time / (60 * 60 * 24));
          let hh = parseInt((time % (60 * 60 * 24)) / 3600);
          let mm = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let ss = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          obj = {
            dd: that.timeFormat(dd),
            // hh: that.timeFormat(hh),
            hh: hh,
            mm: that.timeFormat(mm),
            ss: that.timeFormat(ss)
          };
        } else {
          obj = {
            dd: "00",
            hh: "00",
            mm: "00",
            ss: "00"
          };
        }
        if (that.countDownunm < 0) {
          clearInterval(this.TT);
          // this.overdueWin = true;
          this.win_del = false;
          return;
        }
        that.countDownunm--;
        that.shengyutime = obj.hh + ":" + obj.mm + ":" + obj.ss;
      }, 1000);
    }
    // 计时器结束
  }
};
</script>
<style lang="less" >
#app {
  height: 100%;
}
.bargain {
  width: 100%;
  height: 100%;
  position: relative;
  background: url(../assets/bargain/bargainbg.png) 0 0 no-repeat;
  background-size: 100% 100%;
  .title {
    // position: fixed;
    // top: 0;
    width: 100%;
    height: 0.88rem;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
    .title_text {
      width: 1.68rem;
      font-size: 0.34rem;
      font-weight: bold;
      color: rgba(47, 47, 47, 1);
      line-height: 0.36rem;
      white-space: nowrap;
    }
  }
  .bargain_core_box {
    padding: 0.3rem;
    // margin-top: .88rem;
    .bargain_core {
      height: 11.4rem;
      background: rgba(255, 255, 255, 1);
      height: 100%;
      border-radius: 0.2rem;
      overflow: hidden;
      .bargain_pic {
        width: 1.1rem;
        height: 1.1rem;
        border-radius: 50%;
        margin: 0.42rem auto 0;
      }
      .bargain_username {
        font-size: 0.3rem;
        font-weight: 500;
        color: rgba(47, 47, 47, 1);
        margin-top: 0.19rem;
        text-align: center;
      }
      .bargain_tit {
        font-size: 0.26rem;
        font-weight: 500;
        color: rgba(217, 33, 33, 1);
        margin-top: 0.19rem;
        margin-bottom: 0.29rem;
        text-align: center;
      }
      .bargain_commodity {
        width: 6.5rem;
        height: 2.4rem;
        background: rgba(246, 244, 244, 1);
        border-radius: 0.1rem;
        margin-top: 0.24rem;
        margin-left: 0.2rem;
        display: flex;
        .bargain_pict {
          width: 2rem;
          height: 2rem;
          margin: 0.2rem 0.2rem 0.2rem 0.12rem;
          background: #fff;
          border-radius: .05rem;
        }
        .bargain_rig {
          .bargain_tits {
            width: 4rem;
            font-size: 0.28rem;
            font-weight: bold;
            color: rgba(47, 47, 47, 1);
            margin-top: 0.3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .bargain_over {
            display: flex;
            justify-content: space-between;
            margin-top: 0.7rem;
            div:nth-child(1) {
              font-size: 0.3rem;
              font-weight: bold;
              color: rgba(217, 33, 33, 1);
            }
            div:nth-child(2) {
              font-size: 0.24rem;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
            }
          }
        }
      }
      .progress_bar {
        height: 3.1rem;
        overflow: hidden;
        .stocks {
          margin-top: 0.3rem;
          text-align: center;
          font-size: 0.32rem;
          font-weight: 500;
          span {
            color: rgba(217, 33, 33, 1);
          }
        }
        .bargain_over{
          font-size: .3rem;
          font-weight:bold;
          color:#2F2F2F;
          margin-top: .2rem;
          text-align: center;
        }
        .progress_bar_box {
          width: 5.6rem;
          height: 0.16rem;
          background: rgba(246, 244, 244, 1);
          border-radius: 0.08rem;
          margin-top: 0.24rem;
          margin-left: 0.64rem;
          .progress_bars {
            // width: 4.2rem;
            width: 0;
            height: 0.16rem;
            background: rgba(249, 219, 83, 1);
            border-radius: 0.08rem;
          }
        }
        .bargain_button {
          display: flex;
          justify-content: center;
          div {
            width: 6.5rem;
            height: 0.98rem;
            background: url(../assets/bargain/bargainnaxiu.png) 0 0 no-repeat;
            background-size: 100% 100%;
            text-align: center;
            line-height: 0.98rem;
            margin-top: 0.24rem;
            font-size: 0.32rem;
            font-weight: bold;
            color: rgba(217, 33, 33, 1);
            position: relative;
            animation: mymove 3s infinite;
            -webkit-animation: mymove 3s infinite;
            animation-direction: alternate;
            animation-timing-function: ease-in-out;
            -webkit-animation: mymove 3s infinite;
            -webkit-animation-direction: alternate;
            -webkit-animation-timing-function: ease-in-out;
          }
          @keyframes mymove {
            0% {
              transform: scale(1);
            }
            25% {
              transform: scale(1.03);
            }
            50% {
              transform: scale(1);
            }
            75% {
              transform: scale(1.03);
            }
          }
          @-webkit-keyframes mymove {
            0% {
              transform: scale(1);
            }
            25% {
              transform: scale(1.03);
            }
            50% {
              transform: scale(1);
            }
            75% {
              transform: scale(1.03);
            }
          }
        }
        .bargain_count_down {
          font-size: 0.26rem;
          font-weight: 500;
          color: rgba(47, 47, 47, 1);
          margin-top: 0.17rem;
          text-align: center;
        }
      }
      .bargain_bang {
        width: 6.9rem;
        .bargain_bang_top {
          width: 100%;
          height: 0.88rem;
          background: url(../assets/bargain/bargain_bang.png) 0 0 no-repeat;
          background-size: 6.9rem 0.88rem;
        }
        .bargain_bang_core {
          width: 100%;
          height: 2.5rem;
          overflow: hidden;
          display: flex;
          overflow-x: scroll;
          border: none;
          .bargain_bang_core_list {
            width: 1.5rem;
            border: none;
            .core_pic {
              width: 0.9rem;
              height: 0.9rem;
              border-radius: 50%;
              margin: 0.25rem 0.3rem 0 0.3rem;
            }
            .core_usernamr {
              width: 1rem;
              height: .3rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 0.24rem;
              font-weight: 500;
              color: rgba(153, 153, 153, 1);
              margin: 0.2rem auto;
              text-align: center;
            }
            .core_delprice {
              font-size: 0.28rem;
              font-weight: bold;
              color: rgba(217, 33, 33, 1);
              margin-top: 0.2rem;
              text-align: center;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .bargain_win_box {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    .bargain_win {
      width: 6.2rem;
      height: 6.3rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.2rem;
      margin: 2.76rem auto 0;
      .bargain_win_core {
        overflow: hidden;
        div {
          padding: 0 0.26rem;
          border-bottom: 0.01rem rgba(241, 241, 241, 1) solid;
          display: flex;
          justify-content: left;
          align-items: center;
          input {
            height: 0.45rem;
            border: none;
            outline: none;
            font-size: 0.28rem;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
          }
        }
        .win_one {
          margin-top: 0.95rem;
          height: 0.98rem;
        }
        .win_two {
          height: 0.98rem;
          display: flex;
          div {
            width: 2.15rem;
            justify-content: center;
            font-size: 0.32rem;
            font-weight: 500;
            color: rgba(217, 33, 33, 1);
            border-bottom: none;
            white-space: nowrap;
          }
          div:nth-child(3){
            color: rgba(102, 102, 102, 1);
          }
        }
        .win_three {
          height: 0.98rem;
        }
        .win_four {
          justify-content: center;
          margin-top: 1.1rem;
          div {
            width: 4rem;
            height: 0.88rem;
            background: linear-gradient(
              270deg,
              rgba(217, 33, 33, 1),
              rgba(248, 123, 100, 1)
            );
            border-radius: 0.1rem;
            font-size: 0.34rem;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            justify-content: center;
          }
        }
      }
    }
    .del {
      width: 0.7rem;
      height: 0.7rem;
      margin: 1rem auto;
      img {
        width: 0.7rem;
        height: 0.7rem;
      }
    }
  }
  // 砍价过期弹窗
  .bargain_overdue_box {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 5;
  }
  .bargain_overdue {
    width: 100%;
    height: 100%;
    background: url(../assets/bargain/bargain_guoqi.png) 50% 3.75rem / cover
      no-repeat;
    background-size: 5.6rem 5.7rem;
    z-index: 9;
    overflow: hidden;
  }
  .bargain_overdue_head_box {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    margin: 3.125rem auto 0;
  }
  .bargain_overdue_head {
    width: 1.15rem;
    height: 1.15rem;
    border-radius: 50%;
  }
  .bargain_overdue_txtone {
    display: flex;
    margin-top: 0.48rem;
  }
  .bargain_overdue_txtone .symbol_left {
    width: 0.17rem;
    height: 0.15rem;
    margin-left: 2.1rem;
    margin-right: 0.15rem;
    background: url(../assets/bargain/left.png) 0 0 / cover no-repeat;
    background-size: 0.17rem 0.15rem;
  }
  .bargain_overdue_txtone .symbol_center {
    width: 2.73rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: rgba(47, 47, 47, 1);
    white-space: nowrap;
    position: relative;
    top: -0.1rem;
  }
  .bargain_overdue_txtone .symbol_right {
    width: 0.17rem;
    height: 0.15rem;
    margin-left: 0.15rem;
    background: url(../assets/bargain/right.png) 0 0 / cover no-repeat;
    background-size: 0.17rem 0.15rem;
  }
  .bargain_overdue_txttwo {
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
    color: rgba(47, 47, 47, 1);
    margin-top: 0.15rem;
  }
  .bargain_overdue_box .share_botton {
    width: 3.8rem;
    height: 0.8rem;
    background: linear-gradient(
      270deg,
      rgba(217, 33, 33, 1),
      rgba(248, 123, 100, 1)
    );
    border-radius: 0.4rem;
    text-align: center;
    line-height: 0.8rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    margin-left: 1.82rem;
    margin-top: 2.45rem;
  }
  .bargain_overdue_box .shut_share {
    width: 0.7rem;
    height: 0.7rem;
    margin: 1.35rem 0 0 3.4rem;
  }
  /* 砍价弹窗 */
        .bargain_popup_win_box{
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 5;
            background: rgba(0, 0, 0, 0.8);
        }
        .bargain_popup_win{
            width: 100%;
            height: 100%;
            background: url(../assets/bargain/kjcg.png) 50% 1.4rem / cover no-repeat;
            background-size: 5.6rem 7.43rem;
            z-index: 9;
            overflow: hidden;
        }
        .bargain_popup_core{
            width: 100%;
            margin-top: 3.75rem;
        }
        .pic_top{
          width: 1rem;
          height: 1rem;
          border-radius: .5rem;
          margin: 0 auto;
        }
        .bargain_popup_core .bargain_popup_core_top{
            display: flex;
            justify-content: center;
            position: relative;
            height: .76rem;
            overflow: hidden;
        }
        .bargain_popup_core .bargain_popup_core_top>div{
            margin-top: .25rem;
            font-size: .28rem;
            font-weight:bold;
            color:rgba(102,102,102,1);
        }
        .bargain_popup_core .bargain_popup_core_top>div:nth-child(2){
            margin-top: .25rem;
            font-size: .28rem;
            font-weight:bold;
            color:rgba(217,33,33,1);
        }
        .bargain_popup_core .progress_bar_box{
            width:4.6rem;
            height:.12rem;
            background:rgba(246,244,244,1);
            border-radius: .06rem;
            margin-top: .23rem ;
            margin-left: 1.43rem;
        }
        .bargain_popup_core .progress_bars{
            width: 0;
            height: .12rem;
            background:rgba(249,219,83,1);
            border-radius: .06rem;
        }
        .bargain_popup_core .progress_again{
            height: .77rem;
            margin-top: .25rem;
        }
        .bargain_popup_core .progress_again>div{
          height: .3rem;
          font-size: .24rem;
          font-weight:500;
          text-align: center;
          color:rgba(153,153,153,1);
        }
        .bargain_popup_core .share_txt{
            height: .92rem;
            text-align: center;
            line-height: .92rem;
            font-size: .24rem;
            font-weight:500;
            color:rgba(153,153,153,1);
        }
        .bargain_popup_core .share_botton{
            width: 3.8rem;
            height: .8rem;
            background:linear-gradient(270deg,rgba(217,33,33,1),rgba(248,123,100,1));
            border-radius: .4rem;
            text-align: center;
            line-height: .8rem;
            font-size: .3rem;
            font-weight:bold;
            color:rgba(255,255,255,1);
            margin-top: .6rem;
            margin-left: 1.82rem;
        }
        .bargain_popup_core .shut_share{
            width: .7rem;
            height: .7rem;
            margin: 1.35rem 0 0 3.4rem;
        }
        .wechat-pop .mint-popup-top{
            background: transparent;
            width: 100%;
            text-align: right;
            padding: .3rem
        }
        .wechat-pop .mint-popup-top img{
            width: 80%;
            margin-right: .3rem
        }
}
</style>



// WEBPACK FOOTER //
// src/components/bargain.vue